export const pic_width = 240;
export const pic_height = pic_width * 0.75;
